import type {
  NarrativeMedia,
  NarrativeMediaAsset
} from '~/contracts/vdp/Narratives';

export type SelectedWhyBuyMedia = NarrativeMediaAsset;

const CACHE_BUSTER_PARAM = 'v';

function getMediaKey(url: string): string {
  const queryIndex = url.indexOf('?');
  if (queryIndex === -1) {
    return url;
  }

  const path = url.slice(0, queryIndex);
  const params = url
    .slice(queryIndex + 1)
    .split('&')
    .filter(param => param.split('=')[0] !== CACHE_BUSTER_PARAM);

  return params.length ? `${path}?${params.join('&')}` : path;
}

export default function selectWhyBuyMedia(
  bullets: ReadonlyArray<{ media?: NarrativeMedia | null }>
): Array<SelectedWhyBuyMedia | undefined> {
  const usedKeys = new Set<string>();

  return bullets.map(({ media }) => {
    const candidates = (media?.assets ?? [])
      .filter(({ url }) => url)
      .map((asset, index) => ({ asset, index }))
      .sort(
        (a, b) => a.asset.matchRank - b.asset.matchRank || a.index - b.index
      );

    const selected = candidates.find(
      ({ asset }) => !usedKeys.has(getMediaKey(asset.url))
    );

    if (!selected) {
      return undefined;
    }

    const { assetCategory, matchRank, mimeType, url } = selected.asset;
    usedKeys.add(getMediaKey(url));

    return { assetCategory, matchRank, mimeType, url };
  });
}
